export default "__VITE_ASSET__ACpcc$g$__"